import { Box } from '@mui/material';
import React, { useState } from 'react';
import { DateRange } from './common';
import { useGetReport } from '../utils';
import {
  fileTypes, report_type, minDate, reportTitles,
} from '../constants';
import { createReportRequest } from '../../../../api/reportApi';
import { ReportTemplate } from './ReportTemplate';

const initialForm = {
  date_from: null,
  date_to: null,
  report_status: null,
};

export function MassWasteReport() {
  const [countReports, setCountReports] = useState(null);

  const getReports = async ({ form }) => {
    try {
      const response = await createReportRequest({
        format_type: fileTypes.json,
        report_type,
        kind: reportTitles.mass_waste_transferred_tko,
        options: { ...form, report_status: form.report_status?.value },
      });

      let sum = response?.json_response?.transfer_operator_sum;

      const num = parseFloat(sum);
      if (Number.isInteger(num)) {
        sum = num.toString();
      } else {
        sum = num.toFixed(3);
      }

      setCountReports(sum ?? 0);
    } catch (e) {
      console.log(e);
    }
  };

  const onChangeCallback = ({ name, form, makeRequest }) => {
    if ((name === 'date_from' && form.date_to) || (name === 'date_to' && form.date_from)) makeRequest();
  };

  const {
    onChange,
    form,
    clear,
    loadingCountReports,
    dateError,
    isCleared,
    setIsCleared,
  } = useGetReport({
    initialForm,
    getReports,
    onChangeCallback,
    withMinDate: true,
  });

  const {
    date_to,
    date_from,
  } = form;

  return (
    <ReportTemplate
      clear={clear}
      reportTitle="Период принятия отчета"
      visibleClear={date_from !== null || date_to !== null}
      error={dateError}
      counterOptions={{
        countReports: (!date_from || !date_to) ? '0 тонн' : `${countReports ?? 0} тонн`,
        counterTitle: 'Передано отходов:',
        loadingCountReports,
      }}
    >
      <Box sx={{ display: 'flex', gap: 2 }}>
        <DateRange
          date_to={date_to}
          date_from={date_from}
          onChange={onChange}
          minDate={minDate}
          isCleared={isCleared}
          setIsCleared={setIsCleared}
        />
      </Box>
    </ReportTemplate>
  );
}
